import React from 'react';
import { useStore, useStoreApi, useReactFlow, Panel, ControlButton } from 'reactflow';
import i18n from "i18n-js";
import { IconM } from '@/components/media/IconsV2';

const selector = (s) => ({
    isInteractive: s.nodesDraggable || s.nodesConnectable || s.elementsSelectable,
    minZoomReached: s.transform[2] <= s.minZoom,
    maxZoomReached: s.transform[2] >= s.maxZoom,
});

export default function FlowControls({layoutView}) {
    const store = useStoreApi();
    const { isInteractive, minZoomReached, maxZoomReached } = useStore(selector, (a, b) => a.isInteractive === b.isInteractive && a.minZoomReached === b.minZoomReached && a.maxZoomReached === b.maxZoomReached);
    const { zoomIn, zoomOut, fitView } = useReactFlow();

    const onToggleInteractivity = () => {
        store.setState({
            nodesDraggable: !isInteractive,
            nodesConnectable: !isInteractive,
            elementsSelectable: !isInteractive,
        });
    };

    return (
        <Panel
            className='custom_flow-controls'
            position='bottom-left'
            data-testid='rf__controls'
        >
            <>
                <ControlButton
                    onClick={() => zoomIn()}
                    className='custom_controls-zoomin'
                    title={i18n.t('studio.editor.zoomIn')}
                    aria-label={i18n.t('studio.editor.zoomIn')}
                    disabled={maxZoomReached}
                >
                    <IconM className={maxZoomReached ? 'text-secondary-400' : 'text-secondary-900'} size={24} name='add' />
                </ControlButton>
                <ControlButton
                    onClick={() => zoomOut()}
                    className='custom_controls-zoomout'
                    title={i18n.t('studio.editor.zoomOut')}
                    aria-label={i18n.t('studio.editor.zoomOut')}
                    disabled={minZoomReached}
                >
                    <IconM className={minZoomReached ? 'text-secondary-400' : 'text-secondary-900'} size={24} name='remove' />
                </ControlButton>
            </>
            <ControlButton
                className='custom_controls-fitview'
                onClick={() => fitView()}
                title={i18n.t('studio.editor.fitView')}
                aria-label={i18n.t('studio.editor.fitView')}
            >
                <IconM className='text-secondary-900' size={16} name='fullscreen' />
            </ControlButton>
            {layoutView && <ControlButton
                className='custom_controls-layout'
                onClick={() => layoutView()}
                title={i18n.t('studio.editor.autoLayout')}
                aria-label={i18n.t('studio.editor.autoLayout')}
            >
                <IconM className='text-secondary-900' size={16} name='account-tree' />
            </ControlButton>}
            <ControlButton
                className='custom_controls-interactive'
                onClick={onToggleInteractivity}
                title={i18n.t('studio.editor.lock')}
                aria-label={i18n.t('studio.editor.lock')}
            >
                {isInteractive ? <IconM className='text-secondary-900' size={16} name='lock-open' /> : <IconM className='text-secondary-900' size={16} name='lock' />}
            </ControlButton>
        </Panel>
    );
}